import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { roleIds } from "../constant";
import { resetState } from "../redux/auth/loginSlice";
import { resetData } from "../redux/auth/loginDataSlice";
import HomePage from "./customer/HomePage";

const Home = () => {
  const role_id = useSelector((state) => state.auth.role_id);
  const token = useSelector((state) => state.auth.token);
  const user_id = useSelector((state) => state.auth.user_id);
  const isBlocked = useSelector((state) => state.auth.is_blocked);
  const location = useLocation();

  // console.log("role_id", role_id);

  if (isBlocked) return <Navigate to={"/account-block"} replace />;

  if (!user_id) {
    if (location.pathname.includes("sales")) return <Navigate to="/sales/login" replace />;
    else if (location.pathname.includes("admin")) return <Navigate to="/admin/login" replace />;
    else return <Navigate to="/login" replace />;
  }

  if ([roleIds.SalesManager, roleIds.SalesPerson].includes(role_id))
    return <Navigate to="/sales/dashboard" />;
  if ([roleIds.Admin].includes(role_id)) return <Navigate to="/admin/dashboard" />;
  else if ([roleIds.Customer].includes(role_id)) return <HomePage />;

  return <Navigate to="/unauthorized" />;
};

export default Home;
